module.exports = __webpack_public_path__ + "img/loader.c5651ef.gif";